"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGO_URL = void 0;
exports.LOGO_URL = '/images/alcumus-logo-with-tagline.svg';
